module.exports = __webpack_public_path__ + "static/media/NestedFolder.1d274927.svg";